module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-white-1-70fda81ae6a34c0b9bc22cd4e159f6b9.webp";